export default __webpack_public_path__ + "static/media/Logos.7770cc5f.png";